module.exports = __webpack_public_path__ + "img/buy0145.54c9b831.svg";